import { INotesComponent } from '@modeso/types__aumico-lib-annualreport-be';
import { ViewState } from '../enums/ViewState.enum';

export type NoteComponentViewState = INotesComponent & {
    state?: ViewState;
    isSaveButtonClicked?: boolean;
};
